/* eslint-disable max-len */
import moment from 'moment';
import React, { useEffect, useState, useContext } from 'react';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import { useNavigate } from 'react-router-dom';
import { CognitoData } from '../../../../../CommonMethods/CognitoData';
import GlobalContext from '../../../../../components/Context/GloablContext';

const TableBody = ({lastIndex,tableData, indexNum,searchParams, pageNumber,selectedIndex, setSelectedIndex, selectedRef, setConfirmationState, handleSidePopupClick,email }) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const [userCognitoEmail, setUserCognitoEmail] = useState('');
    const [userType, setUserType] = useState('');
    const location=useNavigate();
    const {isInactiveBranch} = useContext(GlobalContext);

    /**
     * The function onClickActivation handles different actions based on the target id, such as viewing
     * data, resetting passwords, or activating/deactivating an item.
     */
    const onClickActivation = (e) => {
        e.preventDefault();
        setSelectedIndex(null);
        if(e.target.id === 'View') {
            setConfirmationState({item: tableData, view : true})
        } else if(e.target.id === 'Reset Password'){
            setConfirmationState({item: tableData, status: "Reset Password"})      
        }else
        {
            setConfirmationState({item: tableData, status: !tableData.status ? 'Activate' : 'Deactivate'})
        }
    }

    /**
    * The function `handleEditClick` redirects the user to the edit page for a specific institution
    * user based on their email address.
    */
    const handleEditClick = () => {
        location(`/manage-institution-users/edit/${tableData.email_address}`)
    }

    /**
     * The function `handelActionButton` sets the selected index to the provided index number.
     */
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
    }

    /**
    * The function `getCurrentUserData` retrieves the current user's email from Cognito data and sets
    * it as the user's Cognito email.
    */
    const getCurrentUserData = async() => {
        const data = await CognitoData()
        setUserCognitoEmail(data.accessToken.payload.username)
        setUserType(data.idToken.payload["custom:user_type"])
    }

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, it
    is used to call the `getCurrentUserData` function when the component mounts. The
    `getCurrentUserData` function retrieves the current user's email from Cognito data and sets it as
    the user's Cognito email. The empty array `[]` as the second argument to `useEffect` ensures that
    the effect is only run once, when the component mounts. */
    useEffect(() => {
        getCurrentUserData()
    }, []);

    const handleClickViewClick=()=>{
        location(`/fee-management/fee-terms/view-fee-term/${tableData._id}?${searchParams.toString()}`)
    }

    return (
        <>
            <AnimatedList   
                cursorpointer
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        handleClickViewClick()
                    }
                }}
                title={`View Fee Term`}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td class="">
                            {tableData?.fee_term_name}
                        </td>                             
                        <td class="text-left">
                            {tableData?.academic_year?.name}   
                        </td>
                        <td class="px-5 py-3 text-f2 font-normal text-[#031624] text-start">{moment(tableData.created_at).utcOffset('+00:00').format('MMM DD, YYYY')}</td>
                        <td class="text-start">{tableData?.created_by}</td>
                        {/*<td class="px-5 py-3 text-f2 font-normal text-[#031624] text-start">{moment(tableData.updated_at).utcOffset('+00:00').format('MMM DD, YYYY')}</td>
                        <td class="text-start">{tableData?.updated_by}</td>*/}
                        <td class="table-cell">
                            <div className='flex justify-center'>
                                <div className={`rounded ${tableData.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5 w-fit`}>
                                    <img loading="lazy" decoding="async" src={tableData.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                    <span className="pl-1">{tableData.status ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-left prevent-click">
                            <div className="relative flex items-center justify-center prevent-click" data-te-dropdown-ref>
                                <button type='button' className="list-more-btn prevent-click" href="#"
                                    id={tableData.email_address}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" class="prevent-click"/>
                                </button>   
                                {selectedIndex === indexNum && <ul ref={selectedRef} className={`${(indexNum+1 === 10 || indexNum+2 === 10) ? ' top3' : ''} list-more-optns-div [&[data-te-dropdown-show]]:block`}
                                    aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                    {/* <li>
                                        <AnimatedButton 
                                            handleClick={()=>{}} 
                                            buttonName={"View"}
                                            link={`/manage-branches/${tableData._id}`}
                                            className="block w-full whitespace-nowrap bg-transparent px-4 py-1.5 font-normal text-[#000000] text-start hover:font-medium hover:text-[#106EB4]"
                                        />
                                    </li> */}                                   
                                    <>
                                        {(userCognitoEmail !== tableData.email_address) && <><li>
                                            <AnimatedButton
                                                handleClick={() => {}}
                                                // handleClick={handleEditClick}
                                                buttonName={"View Details"}
                                                link={`/fee-management/fee-terms/view-fee-term/${tableData._id}?${searchParams.toString()}`}
                                                className="list-more-optns prevent-click" />
                                        </li>{ !isInactiveBranch && <li>
                                            <AnimatedButton
                                                handleClick={(e) => onClickActivation(e)}
                                                buttonName={!tableData.status ? "Activate" : "Deactivate"}
                                                className="list-more-optns prevent-click" />
                                        </li>}</>}
                                    </>                                                                   
                                </ul>}
                            </div>
                        </td>
                    </>
                }/>
        </>
    );
}

export default TableBody;
